import styles from './RmCardsGroupSeries.module.scss';
import PropTypes from 'prop-types';

const TitleAndLegendBar = (props) => {
    const { title, legend } = props;
    return (
        <div className={styles.titleAndLegendBarWrapper}>
            <div className={styles.titleTextWrapper}>{title}</div>
            <div className={styles.legendWrapper}>{legend}</div>
        </div>
    );
};

TitleAndLegendBar.propTypes = {
    title: PropTypes.string,
    legend: PropTypes.element
};
export default TitleAndLegendBar;
